/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProducedMaterialLoadingMode {
  Open = 'Open',
  Finished = 'Finished',
  All = 'All',
  Update = 'Update'
}
